import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { classNames } from '../../../../../../utils/classname';
import SocialFoundation from '../../../../../foundation/components/Social';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import { SocialMediaPropType } from '../../TeamMember.types';
import './Social.css';
var defaultProps = {
  className: '',
  children: null,
  social: [],
  linked: true,
  showHandle: false
};
export default function Social(_ref) {
  var className = _ref.className,
    children = _ref.children,
    social = _ref.social,
    linked = _ref.linked,
    showHandle = _ref.showHandle;
  if (_isEmpty(social) && _isEmpty(children)) {
    return null;
  }
  var finalClassName = classNames(_defineProperty({
    social: true
  }, className, true));
  if (!_isEmpty(social)) {
    return /*#__PURE__*/React.createElement(SocialFoundation, {
      className: finalClassName
    }, social.map(function (_ref2) {
      var url = _ref2.url,
        platform = _ref2.platform;
      if (_isEmpty(url) && linked || _isEmpty(platform)) {
        return null;
      }
      var icon = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SocialFoundation.Icon, {
        key: platform + url,
        icon: platform.toLowerCase()
      }), showHandle && /*#__PURE__*/React.createElement(SocialFoundation.Handle, {
        link: url
      }));
      if (!linked) {
        return icon;
      }
      return /*#__PURE__*/React.createElement(SocialFoundation.Platform, {
        key: platform + url,
        url: url,
        platform: platform
      }, icon);
    }));
  }
  return /*#__PURE__*/React.createElement(SocialFoundation, {
    className: finalClassName
  }, children);
}
Social.defaultProps = defaultProps;
Social.Platform = SocialFoundation.Platform;
Social.Icon = SocialFoundation.Icon;
Social.Handle = SocialFoundation.Handle;
Social.Label = SocialFoundation.Label;